module.exports = __webpack_public_path__ + "static/media/4bMark.82402cd4.png";